import { createAction } from '../utils/store';

export const login = createAction('USER_LOGIN_REQUEST');
export const logout = createAction('USER_LOGOUT_REQUEST');
export const updateToken = createAction('USER_UPDATE_TOKEN_REQUEST');
export const register = createAction('USER_REGISTER_REQUEST');
export const resetPassword = createAction('USER_RESET_PASSWORD_REQUEST');
export const setUpOTP = createAction('USER_SET_UP_OTP_REQUEST');
